import { UseFormPayload } from '@domain-group/react-hooks'

import { DynamicInput, Form } from '@domain-group/suit-theme'

import useCustomFieldOptionValues from '../../hooks/useCustomFieldOptionValues'

interface DefaultValueProps {
  formPayload: UseFormPayload,
}

const DefaultValue = (props: DefaultValueProps) => {
  const { formPayload } = props

  const {
    entityState: { field_type, options },
    handlers,
  } = formPayload

  const { default_value, input_type } = options || {}

  const {
    hasOptionValues,
    optionValues,
  } = useCustomFieldOptionValues(options)

  if (field_type === 'select' && !hasOptionValues) return null

  return (
    <Form.Field label="Default Value" marginTop="large">
      <DynamicInput
        // @ts-expect-error TS2322
        style={{ height: field_type === 'textarea' ? 80 : null, resize: 'vertical' }}
        currentValue={default_value || ''}
        inputComponent={field_type}
        inputType={input_type}
        name="options.default_value"
        // @ts-expect-error TS2322
        values={optionValues.map(item => ({ key: item.key, label: item.value }))}
        {...handlers}
      />
    </Form.Field>
  )
}

export default DefaultValue
